__webpack_require__.p = "/interactive-card/";